module.exports = __webpack_public_path__ + "img/1526470731.29170a25.jpg";